"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeOrderType = exports.serializeOrderType = void 0;
const entities_1 = require("./entities");
const errors_1 = require("./errors");
const serializeOrderType = (orderType) => orderType.toString();
exports.serializeOrderType = serializeOrderType;
const deserializeOrderType = (orderTypeStr) => {
    switch (orderTypeStr) {
        case 'asc':
            return entities_1.OrderType.ASC;
        case 'desc':
            return entities_1.OrderType.DESC;
        default:
            throw new errors_1.BadOrderTypeError(`Unsupported OrderType '${orderTypeStr}'. Allowed values are ${Object.values(entities_1.OrderType).join(', ')}`);
    }
};
exports.deserializeOrderType = deserializeOrderType;
//# sourceMappingURL=serdes.js.map